export default __webpack_public_path__ + "static/media/logo-1.3ccbb22c.png";